import { render, staticRenderFns } from "./query2.vue?vue&type=template&id=045ab1fa&"
import script from "./query2.vue?vue&type=script&lang=js&"
export * from "./query2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports